import React from "react";
import Table from "react-bootstrap/Table";
import { useEffect } from "react";
import axios from "../axios-interceptor";
import { useState } from "react";
import AdminNavBarMain from "./AdminNavBarMain";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import { decrypt } from "../utils";
import {
  base_url,
  STATUS_NEW,
  STATUS_IN_PROGRESS,
  STATUS_APPROVED,
  STATUS_REJECTED,
  STATUS_PROCESSED,
  SERVICE_REQUEST_NEW_LOAN,
  SERVICE_REQUEST_EXTEND_TENURE,
  SERVICE_REQUEST_PRE_CLOSURE,
  STATUS_CLOSED,
  AUDITOR_ROLE,
} from "../utilities";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment/moment";
import TableData from "./TableData";
import AdminEachLoanBreakUp from "./AdminEachLoanBreakUp";
import AdminNewLoanRequest from "./AdminNewLoanRequest";
import Cookies from 'js-cookie';

const ParticularBusinessloanList = (props) => {
  const { state } = useLocation();
  const businessData = state.props;
  let listOfLoans = [];
  if (businessData.list_of_loans != []) {
    listOfLoans = businessData.list_of_loans;
  }

  let ltwo = props.loading;
  const navigate = useNavigate();
  const [serviceRequests, setServiceRequests] = useState([]);
  const [serviceRequestsfilter, setServiceRequestsFilter] = useState([]);

  const [defaultvalue, setDefaultValue] = useState(false);
  const [loading, setLoading] = useState(true);

  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });
  const [totaListofLoans, setTotalListOfLoans] = useState([...listOfLoans]);
  let count = serviceRequestsfilter.length;

  const [show, setShow] = React.useState(false);
  const [modalShow, setModalShow] = React.useState(false);

  useEffect(() => {

    if (!Cookies.get("User_Accesstoken_Admin")) {
      navigate("/adminlogin");
    }

    
    if (listOfLoans !== "" || listOfLoans !== undefined) {
      listOfLoans.forEach((elem, index) => {
        elem.serial_number = `L${index + 1}`;
      });
      setTotalListOfLoans(listOfLoans);
    }
  }, []);

  const columns = [
    { title: "Loan", field: "serial_number" },
    { title: "Loan Ref No", field: "loan_reference_number" },
    {
      title: "Total Loan",
      field: "admin_request_loan_amount",
      currency: "admin_request_loan_currency",
    },
    {
      title: "Monthly Rate",
      field: "bennefin_roi",
      currency: "admin_request_loan_currency",
    },
    { title: "Status", field: "status" },
    {
      title: "Actions",
      field: "loan_image",
      image: "./images/icons/double_arrow.svg",
      newstatusimg: "./images/eye.svg",
    },
  ];
  const goToAdminDashboard = () => {
    navigate("/listofbusinesses");
  };

  useEffect(() => {
    if (
      Cookies.get("admin_user_id") == null ||
      Cookies.get("admin_user_id") == undefined
    ) {
      navigate("/adminlogin");
    }

    totaListofLoans.forEach((elem) => {
      elem.updated_date_time_number = elem.updated_date_time;
      elem.updated_date_time = moment(elem.updated_date_time).format(
        "D MMM YYYY H:mm"
      );

      if (elem.status === STATUS_NEW) {
        elem.status = "New";
      }
      if (elem.status === STATUS_IN_PROGRESS) {
        elem.status = "In Progress";
      }
      if (elem.status === STATUS_PROCESSED) {
        elem.status = "Processed";
      }
      if (elem.status === STATUS_REJECTED) {
        elem.status = "Rejected";
      }
      if (elem.status === STATUS_APPROVED) {
        elem.status = "Approved";
      }
      if (elem.status === STATUS_CLOSED) {
        elem.status = "Closed";
      }
      if (elem.service_type_code === SERVICE_REQUEST_NEW_LOAN) {
        elem.service_type_name = "New Loan";
      }
      if (elem.service_type_code === SERVICE_REQUEST_EXTEND_TENURE) {
        elem.service_type_name = "Extend Tenure";
      }
      if (elem.service_type_code === SERVICE_REQUEST_PRE_CLOSURE) {
        elem.service_type_name = "Pre Closure";
      }
    });

    setServiceRequests(totaListofLoans);
    setServiceRequestsFilter(totaListofLoans);
    setFirstValue(totaListofLoans);
    setSecondValue(totaListofLoans);
    setThirdValue(totaListofLoans);
    setFourthValue(totaListofLoans);
    setFifthValue(totaListofLoans);
    if (totaListofLoans !== "" || totaListofLoans !== undefined) {
      setLoading(false);
    }
  }, []);

  const [firstValue, setFirstValue] = useState([]);
  const [secondValue, setSecondValue] = useState([]);
  const [thirdValue, setThirdValue] = useState([]);
  const [fourthValue, setFourthValue] = useState([]);
  const [fifthValue, setFifthValue] = useState([]);

  const [initialValue, setInitialValue] = useState('')
  const [secondFilterValue, setSecondFilterValue] = useState('')
  const [thirdFilterValue, setThirdFilterValue] = useState('')
  const [fourthFilterValue, setFourthFilterValue] = useState('')

  const [roleCode, setRoleeCode] = useState(() => {
    const storedRoleeCode = Cookies.get('role_code');
    return storedRoleeCode ? storedRoleeCode : '';
  });

  useEffect(()=>{
    if (roleCode) {
      try {
        const decryptedValueData = decrypt(roleCode);
        setRoleeCode(decryptedValueData);
      } catch (error) {
        console.error('Decryption error:', error);
      }
    }
  },[])

  const handleChangeInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (name === "status" && secondFilterValue ==='' && thirdFilterValue ==='' && fourthFilterValue ==='' ) {
      setInitialValue("status")
      let f = firstValue.filter((item) => {
        if (value === item.status) {
          return item;
        }
        if (value === "All") {
          setInitialValue("")
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setSecondValue(f);
      setThirdValue(f);
      setFourthValue(f);
    }

    if (name === "refNo" && initialValue ==='' && thirdFilterValue ==='' && fourthFilterValue ==='' ) {
      setSecondFilterValue("refNo")
      let f = secondValue.filter((item) => {
        if (value === item.loan_reference_number) {
          return item;
        }
        if (value === "All") {
      setSecondFilterValue("")

          return item;
        }
      });
      setServiceRequestsFilter(f);
      setFirstValue(f);
      setThirdValue(f);
      setFourthValue(f);
      setFifthValue(f);
    }
    if (name === "refNo" && initialValue !=='' ) {
      let f = secondValue.filter((item) => {
        if (value === item.loan_reference_number) {
          return item;
        }
        if (value === "All") {
          setSecondFilterValue("")
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setThirdValue(f);
      setFourthValue(f);
      setFifthValue(f);
    }
    if (name === "totalinv" && initialValue ==='' && secondFilterValue ==='' && fourthFilterValue ==='' ) {
      setThirdFilterValue("totalinv")
      let startRange = value.split("-")[0];
      let endRange = value.split("-")[1];
      let f = thirdValue.filter((item) => {
        let loanamount = Number(item.loan_amount);
        let initialAmount = Number(startRange);
        let finalAmount = Number(endRange);

        if (loanamount >= initialAmount && item.loan_amount <= finalAmount) {
          return item;
        }

        if (value === "All") {
      setThirdFilterValue("")

          return item;
        }
      });
      setServiceRequestsFilter(f);
      setSecondValue(f);
      setFirstValue(f);
      setFourthValue(f);
    }
    if (name === "totalinv" && initialValue !=='') {
      let startRange = value.split("-")[0];
      let endRange = value.split("-")[1];
      let f = thirdValue.filter((item) => {
        let loanamount = Number(item.loan_amount);
        let initialAmount = Number(startRange);
        let finalAmount = Number(endRange);

        if (loanamount >= initialAmount && item.loan_amount <= finalAmount) {
          return item;
        }

        if (value === "All") {
          setThirdFilterValue("")
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setSecondValue(f);
      setFourthValue(f);
      setFifthValue(f);
    }
    if (name === "rate" && initialValue ==='' && secondFilterValue ==='' && thirdFilterValue ==='' ) {
      setFourthFilterValue("rate")
      let NumberValue = Number(value);
      let f = fourthValue.filter((item) => {
        if (NumberValue === Number(item.bennefin_roi)) {
          return item;
        }
        if (value === "All") {
      setFourthFilterValue("")

          return item;
        }
      });
      setServiceRequestsFilter(f);
      setSecondValue(f);
      setThirdValue(f);
      setFirstValue(f);
      setFifthValue(f);
    }
    if (name === "rate" && initialValue !=='' ) {
      let NumberValue = Number(value);
      let f = fourthValue.filter((item) => {
        if (NumberValue === Number(item.bennefin_roi)) {
          return item;
        }
        if (value === "All") {
      setFourthFilterValue("")

          return item;
        }
      });
      setServiceRequestsFilter(f);
      setSecondValue(f);
      setThirdValue(f);
      setFifthValue(f);
    }

    setDefaultValue(false);
  };

  function exportToExcel() {
    let sample_data_array = [];
    serviceRequestsfilter.forEach((elem) => {
      let xl_object = {
        "Loan Ref No.": elem.loan_reference_number,
        "Total Loan": elem.admin_request_loan_currency + " " + elem.loan_amount,
        "Monthly Rate (%)": elem.bennefin_roi,
        "Status": elem.status,
        "Last Activity": elem.updated_date_time,
      };
      sample_data_array.push(xl_object);
    });
    // create the data that you want to write to the excel file
    const data = sample_data_array;

    // create a worksheet and add the data to it
    const worksheet = XLSX.utils.json_to_sheet(data);

    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    // const fileExtension = ".xlsx";
    const fileName = businessData.business_name+"_"+"Loans_List";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
  }
  const clearFilters = () => {
    setServiceRequestsFilter(serviceRequests);
    setDefaultValue(true);
    setFirstValue(serviceRequests);
    setSecondValue(serviceRequests);
    setThirdValue(serviceRequests);
    setFourthValue(serviceRequests);
    setInitialValue('')
    setSecondFilterValue('')
    setThirdFilterValue('')
    setFourthFilterValue('')
  };

  const handleSort = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });

    const sortedData = [...serviceRequestsfilter].sort((a, b) => {
      const columnA = column == "loan_amount" ? parseInt(a[column]) : a[column];
      const columnB = column == "loan_amount" ? parseInt(b[column]) : b[column];

      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setServiceRequestsFilter(sortedData);
  };
  const [singleloandata, setSingleLoanData] = useState([]);
  const handleEachLoan = (props) => {
    setShow(true);
    setSingleLoanData(props);
  };
  const handleNewLoanReqModal = (props) => {
    setModalShow(true);
    // setSingleLoanData(props)
  };

  const uniqueStatus = [...new Set(firstValue.map((d) => d.status))];
  const uniqueRefNo = [
    ...new Set(secondValue.map((d) => d.loan_reference_number)),
  ];
  const uniqueFilterRate = fourthValue.filter((item) => {
    if (
      item.bennefin_roi !== "" &&
      item.bennefin_roi !== undefined &&
      item.bennefin_roi !== null
    ) {
      return item;
    }
  });
  const uniqueRate = [...new Set(uniqueFilterRate.map((d) => d.bennefin_roi))];

  return (
    <div className="">
      <AdminNavBarMain />
      <div
        className="row admin_body_main bg-transparent"
        // style={{ backgroundColor: "whitesmoke" }}
      >
        <div className="d-flex justify-content-between">
          <div className="col d-flex justify-content-between">
            <h5
              className="admin_serv mb-3 mt-3"
              onClick={() => goToAdminDashboard(true)}
            >
              <img
                src="./images/left_arrow.svg"
                alt=""
                className="indiv_loan_dtls "
              />
              &nbsp; {businessData.business_name}
            </h5>
          </div>
        </div>
        <div className="container p-0">
          <div className="row d-flex justify-content-between">
            <div className="col d-flex">
              <div className="col mb-3 ">
                <div className=" blue_style_new">
                  <span> Total Amount Borrowed in Dinar</span>
                  <p className="p_style">
                    {businessData.total_loan_amount_bhd &&
                      "BHD " +
                        Number(
                          businessData.total_loan_amount_bhd
                        ).toLocaleString()}
                  </p>
                </div>
              </div>
              <div className="col mb-3 ">
                <div className=" gray_style_new">
                  <span>Total Amount Borrowed in Dollars</span>
                  <p className="p_style">
                    {businessData.total_loan_amount_usd &&
                      "$ " +
                        Number(
                          businessData.total_loan_amount_usd
                        ).toLocaleString()}
                  </p>
                </div>
              </div>
              <div className="col mb-3 ">
                <div className="blue_style_new pe-4">
                  <span>Current Outstanding In Dinar</span>
                  <p className="p_style">
                    {businessData.total_outstanding_bhd &&
                      "BHD " +
                        Number(
                          businessData.total_outstanding_bhd
                        ).toLocaleString()}
                  </p>
                </div>
              </div>
              <div className="col mb-3 ">
                <div className=" gray_style_new">
                  <span>Current Outstanding In Dollars</span>
                  <p className="p_style">
                    {businessData.total_outstanding_usd &&
                      "$ " +
                        Number(
                          businessData.total_outstanding_usd
                        ).toLocaleString()}
                  </p>
                </div>
              </div>

              <div className="col text-end">
                <div className=" count_of_records_ALLSR">
                  <span>No.of Records : {count}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="row mb-3 gap-3">
            <div className="col">
              <label htmlFor="status" className="form-label">
                <p>Status</p>
              </label>
              <select
                id="status"
                className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                aria-label="form-select example"
                name="status"
                autoComplete="off"
                onChange={handleChangeInput}
              >
                <option selected={defaultvalue}>All</option>

                {uniqueStatus.map((status, index) => {
                  return <option key={index}>{status}</option>;
                })}
              </select>
            </div>
            <div className="col">
              <label htmlFor="refNo" className="form-label">
                <p>Loan Ref No.</p>
              </label>
              <select
                id="refNo"
                className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                aria-label="form-select example"
                name="refNo"
                autoComplete="off"
                onChange={handleChangeInput}
              >
                <option selected={defaultvalue}>All</option>

                {uniqueRefNo.map((refno) => {
                  return <option key={refno}>{refno}</option>;
                })}
              </select>
            </div>

            <div className="col-lg">
              <label htmlFor="totalinv" className="form-label">
                <p>Total Loans</p>
              </label>
              <select
                id="totalinv"
                className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                aria-label="form-select example"
                name="totalinv"
                autoComplete="off"
                onChange={handleChangeInput}
              >
                <option selected={defaultvalue}>All</option>
                <option value="1000-5000">1000 - 5000</option>
                <option value="5001-10000">5001 - 10000</option>
                <option value="10001-50000">10001 - 50000</option>
                <option value="50001-100000">50001 - 100000</option>
                {[...Array(20)].map((_, i) => (
                  <option
                    value={`${i * 50000 + 100001}-${(i + 1) * 50000 + 100000}`}
                  >
                    {i * 50000 + 100001} - {(i + 1) * 50000 + 100000}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-lg-1">
              <label htmlFor="rate" className="form-label">
                <p>Rate</p>
              </label>
              <select
                id="rate"
                className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                aria-label="form-select example"
                name="rate"
                autoComplete="off"
                onChange={handleChangeInput}
              >
                <option selected={defaultvalue}>All</option>
                {uniqueRate.map((rate, index) => {
                  return <option key={index}>{rate}</option>;
                })}
              </select>
            </div>
            <div className=" col align-self-end">
              <button className="blue_btn" onClick={clearFilters}>
                Clear All Filters
              </button>
            </div>

            <div className="col btn_style">
              <button className="blue_btn " onClick={exportToExcel} disabled={roleCode===AUDITOR_ROLE}>
                Download XLS
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="px-5">
        <div className=" perticlr_bus_table">
          <Table
            striped
            // bordered
            className="ps-4 pe-4 text-center "
          >
            <TableData
              handleSort={handleSort}
              ltwo={ltwo}
              data={serviceRequestsfilter}
              columns={columns}
              onImageClick={handleEachLoan}
              onImageTwoClick={handleNewLoanReqModal}
            />
          </Table>
        </div>
      </div>

      <AdminEachLoanBreakUp
        singleloandata={singleloandata}
        listOfLoans={listOfLoans}
        businessData={businessData}
        show={show}
        onHide={() => setShow(false)}
      />
      <AdminNewLoanRequest
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </div>
  );
};

export default ParticularBusinessloanList;
